import { CartPrice } from "src/components/cart/CartPrice"
import { CartProductDeleteButton } from "src/components/cart/CartProductDeleteButton"
import { CartProductImage } from "src/components/cart/CartProductImage"
import { StorefrontCartItem } from "src/components/checkout/types"
import { A } from "src/components/generic/A"
import { routes } from "src/routes"
import { CartProductDetails } from "./CartProductDetails"
import { QuantitySelect } from "./CartQuantitySelect"

export type CartProductProps = {
  item: StorefrontCartItem
}

export const CartProduct = ({ item }: CartProductProps) => {
  return (
    <div className="xs:gap-6 flex w-full items-center gap-4">
      <A href={routes.formatProduct(item.product.slug)}>
        <CartProductImage
          src={item.product.image}
          alt={item.product.name}
          quantity={item.quantity}
          bgClassName="bg-gray-100"
        />
      </A>

      <div className="xs:gap-6 flex w-full items-start gap-4">
        <CartProductDetails item={item} linked />

        <div className="flex shrink-0 flex-col items-end justify-between gap-2">
          <CartPrice item={item} />

          <div className="flex shrink-0 flex-col items-end justify-between gap-2 @3xl:flex-row @3xl:items-center">
            <CartProductDeleteButton item={item} />
            <QuantitySelect item={item} />
          </div>
        </div>
      </div>
    </div>
  )
}
